import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-light border-t border-navy-border pt-16 pb-8" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-81">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-82">
          <div className="lg:col-span-2" data-id="element-83">
            <div className="mb-6" data-id="element-84">
              <Link to="/" data-id="element-85">
                <Logo data-id="element-86" />
              </Link>
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed" data-id="element-87">
              An independent procurement consultancy facilitating sourcing,
              supplier verification, and tender coordination for large-scale
              institutional projects worldwide.
            </p>
          </div>

          <div data-id="element-88">
            <h4 className="text-white font-bold mb-6" data-id="element-89">Quick Links</h4>
            <ul className="space-y-3" data-id="element-90">
              {['Home', 'About', 'Services', 'Sectors'].map(link => <li key={link} data-id="element-91">
                  <Link to={link === 'Home' ? '/' : `/${link.toLowerCase()}`} className="text-slate-400 hover:text-gold transition-colors" data-id="element-92">
                    {link}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-93">
            <h4 className="text-white font-bold mb-6" data-id="element-94">Legal</h4>
            <ul className="space-y-3" data-id="element-95">
              <li data-id="element-96">
                <a href="#" className="text-slate-400 hover:text-gold transition-colors" data-id="element-97">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-98">
                <a href="#" className="text-slate-400 hover:text-gold transition-colors" data-id="element-99">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-100">
          <p className="text-slate-500 text-sm" data-id="element-101">
            © {currentYear} 888 Sourcing Limited. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm" data-id="element-102">
            Global Procurement & Strategic Sourcing
          </p>
        </div>
      </div>
    </footer>;
}